<template>
  <div class="allDetail" v-loading="dLoading" element-loading-text="问题详情获取中..." :key="formKey">
    <div class="read" v-show="isRead" >
      <el-form ref="formData" :model="formData" size="small" label-width="80px" label-position="right">
        <el-form-item label="状态">
          <el-popover placement="bottom" width="300" v-model="visible" trigger="manual">
            <el-form ref="formstatus" :rules="statusRules" :model="formstatus" class="statusForm" size="mini" label-position="top">
              <el-form-item label="问题状态:" prop="statusId">
                <el-select size="small"  v-model="formstatus.statusId" placeholder="请选择" >
                  <el-option v-for="item in dicData.dealList" :key="item.id" :label="item.cnName" :value="item.id"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item  class="footer">
                <el-button size="mini" @click="visible = false">取 消</el-button>
                <el-button size="mini" type="primary" @click="changeStatus" >确 定</el-button>
              </el-form-item>
            </el-form>
            <div slot="reference" class="changeStatus" :class="'status' + statusIndex" @click="dealStatus">
              <span>{{formData.queStatus}}</span>
              <i class="el-icon-arrow-down"></i>
            </div>
          </el-popover>
        </el-form-item>
        <el-form-item label="专业" class="formItem">{{formData.multiSpecList ? formData.multiSpecList.map(item => item.specName).join(',') : ''}}</el-form-item>
        <el-form-item label="问题类型" class="formItem">{{formData.qmType}}</el-form-item>
        <el-form-item label="文件名">
          <div class="file-name__wrapper">
            <div class="file-name" v-for="(item, index) in fileNames" :key="index" :title="fileNamesString">{{ item }}</div>
          </div>
        </el-form-item>
        <el-form-item label="位置" class="file-name" :title="formData.textProperties">{{formData.textProperties}}</el-form-item>
        <el-form-item label="修改方" class="formItem">{{formData.modifierName}}</el-form-item>
        <el-form-item label="创建人" class="formItem">{{formData.creatorName}}</el-form-item>
        <el-form-item label="创建时间" class="formItem">{{formData.createDate}}</el-form-item>
        <el-form-item label="关联文件" class="associatedFileStyle">
          <ul>
            <li v-for="(item, index) in floderData" :key="index">
              <div class="fileNamestyle" :title="item.fileName">{{item.fileName}}</div>
              <div><img :src="down" alt="下载" style="margin-left: 10px" @click="todown(item)"></div>
            </li>
          </ul>
        </el-form-item>
        <el-form-item label="审图要点" class="formItem">{{formData.drawingReviewPoints}}</el-form-item>
        <!-- <el-form-item label="阶 段:" v-if="stageNameBoolean">{{stageName}}</el-form-item>
        <el-form-item label="子 项:" v-if="childNameBoolean">{{childName}}</el-form-item> -->
        <!-- <el-form-item label="跨 专 业:">{{multiSpecName}}</el-form-item> -->
        <!-- <el-form-item label="问题来源:">{{formData.source}}</el-form-item> -->
      </el-form>
    </div>
    <div class="edit" v-show="!isRead">
      <el-form ref="editform" :rules="rules" class="editform" :model="editform" size="small" label-width="90px" label-position="left">
        <el-form-item label="状态">
          <div class="changeStatus" :class="'status' + statusIndex" >{{formData.queStatus}}</div>  
        </el-form-item>
        <el-form-item size="small"  label="专 业" prop="multiSpecListspecIds">
          <el-select  v-model="editform.multiSpecListspecIds" placeholder="请选择专业" multiple filterable>
            <el-option v-for="item in multiSpecList" :key="item.id" :label="item.cnName" :value="item.id" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="问题类型" prop="qmTypeId" key="qmTypeId">
          <el-select v-model="editform.qmTypeId" placeholder="请选择问题类型">
            <el-option v-for="item in dicData.checkTypeList" :key="item.id" :label="item.cnName" :value="item.id" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文件名" class="changeBgc">
          <div class="content" :title="formData.fileName">{{formData.fileName}}</div>
        </el-form-item>
        <el-form-item label="位置" class="formItem">
          <el-input v-model="editform.textProperties" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="修改方">
          <el-select v-model="editform.modifierIds" filterable placeholder="请选择修改方" clearable>
            <el-option-group
              v-for="group in dicData.modifierList"
              :key="group.label"
              :label="group.label"
            >
              <el-option v-for="item in group.options" :key="item.id" :label="item.cnName" :value="item.id" ></el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="创建人" class="changeBgc">
          <div class="content contentItem">{{formData.creatorName}}</div>
        </el-form-item>
        <el-form-item label="创建时间" class="changeBgc">
          <div class="content">{{formData.createDate}}</div>
        </el-form-item>
        <!-- <el-form-item label="严重等级:" prop="problemTypeId" key="problemTypeId">
          <el-select v-model="editform.problemTypeId" placeholder="请选择严重等级">
            <el-option v-for="item in dicData.severityLevelList" :key="item.id" :label="item.cnName" :value="item.id"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="关联文件" class="associatedFileStyle">
          <div class="labelStyle">
            <el-button class="rcStyle" type="primary" plain size="mini" @click="showAssociatedFile" >关 联 文 档</el-button >
            <el-button class="rcStyle" type="primary" plain size="mini" @click="uploadFiles" >本 地 上 传</el-button >
          </div>
          <ul>
            <li v-for="(item,index) in floderData" :key="index">
              <div class="fileNamestyle" :title="item.fileName">{{item.fileName}}</div>
              <div>
                <img :src="down" alt="下载" @click="todown(item)">
                <img :src="del" alt="删除" style="margin-left: 10px" @click="todel(index)">
              </div>
            </li>
          </ul>
        </el-form-item>
        <el-form-item label="审图要点" class="itemStyle">
          <el-button type="primary" plain size="mini" @click="showImgPoint" style="width:100%">关联审图要点</el-button >
          <el-input type="textarea" v-model="editform.drawingReviewPoints" readonly ></el-input>
        </el-form-item>
        
        <!-- <template v-if="stageNameBoolean">
          <el-form-item label="阶 段:" class="changeBgc" v-if="stageName">
            <span class="content"> {{ stageName }}</span>
          </el-form-item>
          <el-form-item label="阶 段:"  v-else>
            <el-select size="small"   v-model="editform.stageId" placeholder="请选择阶段" >
              <el-option v-for="item in dicData.specStageChildVos.find(ele=>ele.name=='阶段').optionalValues" :key="item.id" :label="item.cnName" :value="item.id" ></el-option>
            </el-select>
          </el-form-item>
        </template> -->
      
        <!-- <el-form-item  label="跨 专 业:">
          <el-select  v-model="editform.multiSpecListspecIds" placeholder="请选择跨专业" multiple collapse-tags filterable>
            <el-option v-for="item in multiSpecList" :key="item.id" :label="item.cnName" :value="item.id" ></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <template v-if="childNameBoolean">
          <el-form-item  label="子 项:" class="changeBgc" v-if="childName">
            <span class="content">{{ childName}}</span>
          </el-form-item>
          <el-form-item  label="子 项:"  v-else>
            <el-select v-model="editform.stageChildId" placeholder="请选择子项">
              <el-option size="small" v-for="item in dicData.specStageChildVos.find(ele=>ele.name == '子项').optionalValues" :key="item.id" :label="item.cnName" :value="item.id" ></el-option>
            </el-select>
          </el-form-item>
        </template> -->
        <!-- <el-form-item label="问题来源:" class="changeBgc">
          <span class="content">{{formData.source}}</span>
        </el-form-item> -->
        <!-- <el-form-item  class="footer">
          <el-button size="mini" @click="closeEdit">取 消</el-button>
          <el-button size="mini" type="primary" v-loading="addLoading"  @click="sureEdit">确 定</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <check-img-point v-if="imgPoint" ref="checkImgPoint" />
    <associated-file v-if="associatedFileShow" ref="associatedFile"/>
    <!-- <uploader ref="uploader"/> -->
  </div>
</template>

<script>
const editParams =()=>({
  problemTypeId:'',//严重等级
  drawingReviewPoints:'',//要点
  modifierIds:'',//修改人
  qmTypeId:'',//问题类型
  stageId:'',//阶段
  specId:'',//专业
  multiSpecListspecIds:[],
  stageChildId:'',
  textProperties:''
})
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";
Vue.use(Viewer);
import requestIssueMg from "@/CommonDP/service/question-service";
import question from "@/xgzdService/question-service"
import checkImgPoint from "@/CommonDP/components/checkImgPoint/index.vue";
import associatedFile from "@/CommonDP/components/associatedFile/index.vue";
// import uploader from "@/CommonDP/components/UploaderForPerFileDan/Uploader";
import { uploader } from "@/CommonDP/utils/IUploader/dp";
import { mapState } from "vuex";
import {  downloadUrltoken } from "@/utils";
import request from "@/CommonDP/service/XtDesign-service";
const POOL_STATUS = [
  { id: 1, cnName: '待修改' },
  { id: 2, cnName: '已修改' },
  { id: 3, cnName: '不修改' },
  { id: 4, cnName: '已销项' }
]
export default {
  components:{
    checkImgPoint,
    associatedFile ,
    // uploader
  },
  props:{
    checkContent:{
      type:String,
      default:()=>""
    }
  },
  data(){
    return{
      isRead:true,
      dLoading:false,
      addLoading:false,
      formData:{},
      dicData:{
        dealList:[],
      },
      editform:editParams(),
      imgPoint:false,
      formstatus:{//修改问题状态
        statusId:'',//问题id
        content:'',
      },
      visible:false,
      currentUserID:'',
      statusRules:{
        statusId: [
          { required: true, message: "问题状态不可为空", trigger: "change" },
        ],
      },
      rules:{
        problemTypeId:[
          { required: true, message: "严重等级不可为空", trigger: "change" },
        ],
        specId: [
          { required: true, message: "请选择专业", trigger: "change" }
        ]
      },
      stageName:'',
      stageNameBoolean:false,
      specName:'',
      specNameBoolean:false,
      multiSpecName:"",
      multiSpecNameBoolean:false,
      childName:'',
      childNameBoolean:false,
      associatedFileShow:false,
      floderData:[],
      down:require('@/CommonDP/assets/issueMgDown.png'),
      del:require('@/CommonDP/assets/issueMgDel.png'),
      formKey:0,
      folderId:''
    }
  },
  computed:{
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      userInfo: state => state.user.userInfo,
      enterpriseId: (state) => state.enterprise.enterpriseId,
    }),
    fileNames() {
      const names = (this.formData.fileList || []).map(item => item.fileName)
      return names
    },
    fileNamesString(){
      return this.fileNames?.join(',')
    },
    multiSpecList(){
      if(this.dicData.specList&&this.dicData.specList.length>0&&this.editform.specId)
      return this.dicData.specList
    },
    editallParams(){
      const {problemTypeId,drawingReviewPoints,modifierIds,qmTypeId,
        specId,multiSpecListspecIds,textProperties}=this.editform;
      let annexFileList =[]
      if(!!this.floderData&&this.floderData.length){
        this.floderData.forEach(ele=>{
          let obj={fileId:ele.fileId,fileName:ele.fileName,id:'',uploadType:ele.uploadType}
          annexFileList.push(obj)
        })
      }
      let modifierList=[]//修改人多选
      let multiSpecList=[]
      if(modifierIds){
        let list = [...this.dicData.modifierList[0].options, ...this.dicData.modifierList[1].options]
        let selectItem = list.find(sor=>sor.id == modifierIds)
        let obj={modifierId:modifierIds, modifierName:selectItem?.cnName, type:selectItem.remark };
        modifierList.push(obj);
      }
      
      if(multiSpecListspecIds.length){
        multiSpecListspecIds.forEach(ele=>{
          let obj={specId:ele, specName:this.dicData.specList.find(sor=>sor.id == ele )?.cnName }
          multiSpecList.push(obj)
        })
      }
     
      let specName = this.dicData.specList&&specId?this.dicData.specList.find(item => item.id === specId)?.cnName:"";
      let newcoordinatedata = ''
      if (this.formData.coordinate) {
        const newcoordinate = JSON.parse(this.formData.coordinate)
        if (newcoordinate.stMarkNewInfo) {
          newcoordinate.stMarkNewInfo.strText = this.checkContent
        }
        newcoordinatedata = JSON.stringify(newcoordinate)
      }
      

      const params={
        textProperties,
        checkContent:this.checkContent,
        drawingReviewPoints,
        modifierList,
        problemTypeId,
        problemType:this.dicData.severityLevelList.find(ele=>ele.id == problemTypeId)?.cnName,
        qmTypeId,
        qmType:this.dicData.checkTypeList.find(ele=>ele.id == qmTypeId)?.cnName,
        questionId:this.formData.questionId,
        prjId:this.formData.prjId,

        multiSpecList,
       
        specId,
        specName,
        
        annexFileList,
        coordinate:newcoordinatedata
      }
      return params
    },
    statusParams(){
      const {statusId,content}=this.formstatus,
      params={
        content,
        prjId: this.formData.prjId,
        idList: [this.formData.questionId],
        statusId: this.formData.queStatusId,
        statusName: this.formData.queStatus,
        toStatusId: statusId,
        toStatusName: this.dicData.statusList.find(ele=>ele.id == statusId)?.cnName
      }
      return params
    },
    statusIndex(){
      const id=POOL_STATUS?.find(ele=>ele.cnName===this.formData.queStatus)?.id
      return id
    }
  },
  methods:{
    dealStatus(){
      const {queStatus} = this.formData;
      this.visible = true;
      this.currentUserID=this.userInfo.userId;
      this.dicData.dealList=this.dicData.statusList.filter(item=>item.cnName!==queStatus)
      this.formstatus.statusId=''
      this.$refs.formData.clearValidate()
    },
    async changeStatus(){
      this.$refs.formstatus.validate(async (valid) => {
        if (valid) {
          try {
            const res = await question.drawingannotationupdateStatus(this.statusParams);
            if(res.result =='0'){
              this.$message.success("修改成功")
              this.visible = false
              this.$emit("update")
              this.getDetail(this.formData.questionId)
              this.isRead = true
            }
          } catch (error) {
            this.visible = false
          }
        }
      })
        
    },
    async getDetailInit(questionId,prjId,fileId){
      this.formData=editParams()
      this.editform=editParams()
      this.isRead = true
      this.imgPoint=false
      this.associatedFileShow=false
      await this.getDic(prjId,fileId,questionId);
      await this.getDetail(questionId)
    },
    async getDic(prjId,fileId,questionId){
      let id = fileId.includes(',')? '': fileId
      const res = await question.getNotationDic(prjId,id)
      let list = res.data || {};
      let roleList = { label: '角色', options: res.data.roleList };
      let userList = { label: '用户', options: res.data.userList };
      list.modifierList = [roleList, userList]
      this.dicData = list;
    },
    async getDetail(questionId){
      this.visible = false
      this.dLoading =true
      try {
        const res = await question.getDrawingQuestionDetailsLc(questionId)
        if(res.result =='0'){
          this.formData = res.data;
          if(this.formData.modifierList.length>0)this.formData.modifierName=this.formData.modifierList[0].modifierName;
          this.floderData=[];
          let multiSpecName=[];
          this.multiSpecName=[];
          if(!!res.data.annexFileList&&res.data.annexFileList.length){
            this.floderData = res.data.annexFileList;
          }
          this.editform.problemTypeId = this.formData.problemTypeId;//严重等级
          this.editform.qmTypeId = this.formData.qmTypeId;
          this.editform.specId = this.formData.specId;
          this.editform.textProperties= this.formData.textProperties;
          this.editform.drawingReviewPoints = this.formData.drawingReviewPoints;
          if(this.formData.modifierList.length>0)this.editform.modifierIds=this.formData.modifierList[0].modifierId;
          this.formData.multiSpecList.forEach(element => {
            multiSpecName.push(element.specName)
          });
          this.multiSpecName=multiSpecName.join(',')
         
          this.dLoading = false;
        }else{
          this.dLoading =false
        }
      } catch (error) {
        console.log(error);
        this.dLoading =false
      }
      this.formKey++
    },
    //编辑
    openEdit(){
      if(this.formData.multiSpecList){
        let list = this.dicData.specList
        let ids=[];
        this.formData.multiSpecList.forEach(item=>{
          let obj = list.find(ele => ele.cnName == item.specName)
          if(obj) {
            ids.push(obj.id)
          }
        })
        this.editform.multiSpecListspecIds = ids
      }
      this.isRead = false;
    },
    //确定编辑
    async sureEdit(){
      this.$refs.editform.validate(async (valid) => {
        if(valid){
          this.addLoading =true
          try {
            console.log(this.editallParams);
            const res = await requestIssueMg.DrawingQuestionEdit(this.editallParams );
            if(res.result =='0'){
              this.$message.success("编辑成功");
              this.addLoading =false
              this.getDetail(this.formData.questionId)
              this.isRead = true
              this.imgPoint=false
              this.associatedFileShow=false
              // this.$emit.$emit.$refs.checkLabel2D.queryEvent()
            }
          } catch (error) {
            console.log(error);
            this.addLoading =false
          }
        }else{
          this.$message.info("必填项不可为空");
        }
      })
    },
    //取消编辑
    closeEdit(){
      this.editform = editParams();
      this.getDetail(this.formData.questionId)
      this.isRead = true
    },
    showImgPoint(){
      this.imgPoint = true;
      this.$nextTick(() => {
        this.$refs.checkImgPoint.showDialog();
        this.$refs.checkImgPoint.getAlldata();
      });
    },
    //  获取点击的审图要点数据
    getPointInfo(val) {
      this.editform.drawingReviewPoints = val.mainPoint || "";
      this.imgPoint = false;
    },
    showAssociatedFile(){
      this.associatedFileShow = true;
      this.$nextTick(() => {
        this.$refs.associatedFile.showDialog();
      });
    },
    // 关联文档数据
    getAssociatedFile(val){
      this.associatedFileShow = false;
      let arr1= val
      let arr2 = this.floderData
      let arr1fileNames = new Set(arr1.map(({ fileName }) => fileName));
      let isfloderData = [...arr1, ...arr2.filter(({ fileName }) =>!arr1fileNames.has(fileName))];
      let isnotfloderData = [...arr2.filter(({ fileName }) =>arr1fileNames.has(fileName))];
      this.floderData=isfloderData
      for(let key in isnotfloderData){
        setTimeout(()=>{
          this.$message.warning(`文件${isnotfloderData[key].fileName}上传失败，已存在同名文件`);
        },10)
      }
    },
    // 本地上传
    async uploadFiles(){
      // this.$store.dispatch("annotationUploadFloderData", this.floderData);
      // this.$store.dispatch("annotationUploadType", new Date().getTime());
      await this.getFolder();
      const params = {
        prjId: this.formData.prjId,
        folderId: this.folderId,
        versionId: ""
      };
      const list = await uploader.open({ params, showPanel: true, once: true });
      list.forEach(this.fileAdded);
    },
    // 接收上传文件
    fileAdded(val) {
      const info = this.floderData?.find(ele=>ele.fileName===val.fileName)
      if(info){
        return this.$message.warning(`文件${val.fileName}上传失败，已存在同名文件`);
      }else if (val.fileId) {
        this.floderData.push(val);
      }
    },
    async getFolder() {
      const oldId = "folderhide000001";
      const params = {
        oldId,
        enterpriseId: this.enterpriseId,
        prjId: "EnterpriseDoc"
      };
      const { data } = await request.docGetFolderId(params);
      this.folderId = data;
    },
    todown(row){
      const prjId = this.formData.prjId;
      const fileId = row.fileId;
      const fileUrl = downloadUrltoken(prjId, fileId);
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.style.height = 0;
      iframe.src = fileUrl;
      document.body.appendChild(iframe);
      setTimeout(() => {
        iframe.remove();
      }, 5 * 60 * 1000);
    },
    todel(index){
      const obj = {};
      this.floderData = this.floderData.reduce((cur, next) => {
        obj[next.fileId] ? "" : (obj[next.fileId] = true && cur.push(next));
        return cur;
      }, []); // 设置cur默认类型为数组，并且初始值为空的数组
      this.floderData.splice(index, 1);
    }
  }
}
</script>

<style lang="scss" scoped>
.allDetail{
  width: 100%;
  height: calc(100% - 58px);
  padding: 10px 5px 0 0;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  .edit{
    /deep/.el-select{
      width: 100%;
    }
  }
  .MQcut{
    width: 100%;
    height: 80px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .uploadpic{
      width: 75px;
      height: 75px;
      margin-right: 5px;
      cursor: pointer;
    }
  }
  .itemStyle {
    width: 100%;
    .el-form-item__label {
      width: 100% !important;
      display: flex;
    }
    .el-form-item__content {
      margin-top: 30px;
    }
  }
  /deep/.el-form-item__label{
    font-weight: 600;
    text-align: justify;
    text-align-last: justify;
  }
  .associatedFileStyle{
    width: 100%;
    .el-form-item__label {
      width: 100% !important;
      display: flex;
    }
    .el-form-item__content {
      margin-top: 30px;
    }
    li{
      display: flex; 
      justify-content: space-between;
      cursor: pointer;
      .fileNamestyle{
        color:#3873FE;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 150px;
        padding-left: 5px;
      }
    }
    li:hover{
      background:#EEF1FF;
    }
  }
  .labelStyle {
    font-size: 14px;
    line-height: 28px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 10px;
    > span {
      font-size: 14px;
      line-height: 28px;
      margin-right: 10px;
    }
  }
  .changeBgc{
    >>>.el-form-item__content{
      box-sizing: border-box;
      padding-left: 15px;
      background: rgba(179,201,253,.122);
    }
  }
  .footer{
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
  .changeStatus{
    width: 100%;
    cursor: pointer;
    border-radius: 4px;
    padding-right: 10px;
  }
  .status1{
    background:#fce9df;
    color:#eb5757;
  }
  .status2{
    background:#ffffdf;
    color:#eac100;
  }
  .status3{
    background:#F2F2F2;
    color:#8b8888
  }
  .status4{
    background:#def6e4;
    color:#00b632;
  }
  .statusForm{
    padding: 5px 15px;
    box-sizing: border-box;
  }
}
.allDetail::-webkit-scrollbar {
  width: 6px;
}
.allDetail::-webkit-scrollbar-thumb {
  border-radius: 3px;
  box-shadow: inset 0 0 4px rgba(0,0,0,.3);
  background-color: #E8E8E8;
}
.allDetail::-webkit-scrollbar-track {
  box-shadow: inset 0 0 4px rgba(0,0,0,.3);
  background-color: #fff;
  border-radius: 3px;
}
.content{
  user-select: none;
  width: 100%;
  font-size: 14px;
  line-height: 30px;
  white-space: nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
  color: #ccc;
}
/deep/.el-form-item{
  margin-bottom: 7px;
}
.file-name__wrapper{
  width: 100%;
  color: #ccc;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.file-name{
  color: #ccc;
  display: inline;
  /deep/.el-form-item__content{
    width: 70%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #ccc;
  }
}
.formItem{
  /deep/.el-form-item__content{
    color: #ccc;
  }
}
.contentItem{
  width: 100%;
  background: rgba(210, 210, 211, 0.12);
}
.el-icon-arrow-down{
  float: right;
  line-height: 30px;
  font-size: 18px;
}
</style>